module.exports = __webpack_public_path__ + "static/media/compassireland.68baf091.png";